import { HStack } from '@chakra-ui/react';
import ProfileDropdownMenu from '../../ProfileDropdownMenu';
import NotificationsBell from '../../NotificationsBell';
import { text } from '@/theme/colors/palettes';
import { useRouterState } from '@tanstack/react-router';
import { useAppStore } from '@/store/useAppStore';

interface Props {
  isTransparent: boolean;
}

const DefaultHeader = ({ isTransparent }: Props) => {
  const hasUnacceptedLegalDocuments = useAppStore((state) => state.hasUnacceptedLegalDocuments);
  const pathname = useRouterState({ select: (state) => (state.resolvedLocation ?? state.location).pathname });
  const isOnboarding = pathname.includes('onboarding');

  return (
    <HStack gap="10px">
      {!isOnboarding && !hasUnacceptedLegalDocuments && (
        <NotificationsBell color={isTransparent ? 'white' : text.mediumBlue} />
      )}
      <ProfileDropdownMenu isHeaderTransparent={isTransparent} />
    </HStack>
  );
};

export default DefaultHeader;
